'use client';

import { useState } from 'react';
import { API_BASE_URL } from '../lib/config';

export default function AdminPanel({ sessionId }) {
  const [activeTab, setActiveTab] = useState('users');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clearing, setClearing] = useState(false);

  const fetchData = async (endpoint) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId })
      });

      if (response.ok) {
        const result = await response.json();
        setData(result);
      } else {
        const err = await response.json();
        setError(err.error || 'Failed to fetch data');
      }
    } catch (error) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  const clearData = async () => {
    if (!confirm(`Are you sure you want to delete ALL ${activeTab}? This cannot be undone!`)) {
      return;
    }

    setClearing(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/${activeTab}/clear`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId })
      });

      if (response.ok) {
        const result = await response.json();
        alert(`Successfully deleted ${result.deletedCount} ${activeTab}`);
        setData(null);
      } else {
        const err = await response.json();
        setError(err.error || 'Failed to clear data');
      }
    } catch (error) {
      setError('Network error');
    } finally {
      setClearing(false);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setData(null);
    setError(null);
  };

  return (
    <div style={{
      marginTop: '2rem',
      padding: '1.5rem',
      background: '#f9fafb',
      borderRadius: '8px',
      border: '2px solid #e5e7eb'
    }}>
      <h2 style={{ marginBottom: '1rem', fontSize: '20px', fontWeight: 'bold', color: '#dc2626' }}>
        🔒 Admin Panel
      </h2>

      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <button
          onClick={() => handleTabChange('users')}
          style={{
            padding: '0.5rem 1rem',
            background: activeTab === 'users' ? '#3b82f6' : '#e5e7eb',
            color: activeTab === 'users' ? 'white' : '#374151',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: activeTab === 'users' ? 'bold' : 'normal'
          }}
        >
          Users
        </button>
        <button
          onClick={() => handleTabChange('sessions')}
          style={{
            padding: '0.5rem 1rem',
            background: activeTab === 'sessions' ? '#3b82f6' : '#e5e7eb',
            color: activeTab === 'sessions' ? 'white' : '#374151',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: activeTab === 'sessions' ? 'bold' : 'normal'
          }}
        >
          Sessions
        </button>
        <button
          onClick={() => handleTabChange('games')}
          style={{
            padding: '0.5rem 1rem',
            background: activeTab === 'games' ? '#3b82f6' : '#e5e7eb',
            color: activeTab === 'games' ? 'white' : '#374151',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: activeTab === 'games' ? 'bold' : 'normal'
          }}
        >
          Games
        </button>
      </div>

      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <button
          onClick={() => fetchData(activeTab)}
          disabled={loading}
          style={{
            padding: '0.75rem 1.5rem',
            background: loading ? '#9ca3af' : '#10b981',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontWeight: 'bold'
          }}
        >
          {loading ? 'Loading...' : `Fetch ${activeTab}`}
        </button>
        
        <button
          onClick={clearData}
          disabled={clearing || loading}
          style={{
            padding: '0.75rem 1.5rem',
            background: clearing ? '#9ca3af' : '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: clearing || loading ? 'not-allowed' : 'pointer',
            fontWeight: 'bold'
          }}
        >
          {clearing ? 'Clearing...' : `Clear All ${activeTab}`}
        </button>
      </div>

      {error && (
        <div style={{
          padding: '1rem',
          background: '#fee2e2',
          color: '#dc2626',
          borderRadius: '4px',
          marginBottom: '1rem'
        }}>
          {error}
        </div>
      )}

      {data && (
        <div style={{
          background: '#1f2937',
          color: '#f3f4f6',
          padding: '1rem',
          borderRadius: '4px',
          overflow: 'auto',
          maxHeight: '500px'
        }}>
          <pre style={{ margin: 0, fontSize: '12px', whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}
